import { useAuth } from '@/lib/auth/auth';
import type { MeResult } from '@/lib/api/apiTypes';
import { locationStore } from '@/lib/location/location';
import * as React from 'react';

export function useMarketLocationSync() {
  const session = useAuth((state) => state.session);
  const syncMarketLocation = useAuth((state) => state.syncMarketLocation);
  const coords = locationStore((state) => state.coords);
  const isReady = locationStore((state) => state.isReady);
  const permissionDenied = locationStore((state) => state.permissionDenied);

  return React.useCallback(async (): Promise<MeResult | null> => {
    if (!session || !isReady || permissionDenied) {
      return session?.me ?? null;
    }

    return syncMarketLocation(coords.latitude, coords.longitude);
  }, [
    coords.latitude,
    coords.longitude,
    isReady,
    permissionDenied,
    session,
    syncMarketLocation,
  ]);
}
